import { Hero } from "@/components/home/Hero";
import { WhyChoose } from "@/components/home/WhyChoose";
import { ProgramsSection } from "@/components/home/ProgramsSection";
import { Manifesto } from "@/components/home/Manifesto";
import { Testimonials } from "@/components/Testimonials";
import { TeamCards } from "@/components/TeamCards";
import { GalleryGrid } from "@/components/GalleryGrid";
import { FaqAccordion } from "@/components/FaqAccordion";
import { CTASection } from "@/components/CTASection";
import { BrandMarquee } from "@/components/BrandMarquee";
import { Reveal } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/useSeo";

export default function Home() {
  useSeo({
    title: "DST New Braunfels | Sports Performance & Training for Baseball & Softball, New Braunfels TX",
    description:
      "Dynamic Sports Training (DST) in New Braunfels, TX. Elite sports performance, baseball & softball instruction, and youth athletic training. Book your first session — 830-832-9898.",
  });

  return (
    <>
      <Hero />
      <BrandMarquee theme="red" />
      <WhyChoose />
      <ProgramsSection />
      <Manifesto />

      {/* Team preview */}
      <section data-testid="team-preview" className="bg-dst-light text-dst-ink py-24 lg:py-32">
        <div className="container-dst">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
            <Reveal>
              <span className="eyebrow text-dst-red">Meet The Team</span>
              <h2 className="mt-4 font-oswald font-700 uppercase tracking-tighter leading-[0.9] text-5xl lg:text-7xl text-dst-navy">
                Coaches Who<br />Compete With You
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <Link to="/team" className="btn-dst bg-dst-navy text-white hover:bg-dst-red">
                Full Team <ArrowRight size={18} />
              </Link>
            </Reveal>
          </div>
          <div className="[&_h3]:text-white">
            <TeamCards />
          </div>
        </div>
      </section>

      {/* Gallery preview */}
      <section data-testid="gallery-preview" className="bg-dst-ink py-24 lg:py-32 grain">
        <div className="container-dst relative z-10">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
            <Reveal>
              <span className="eyebrow text-dst-red">Inside The Facility</span>
              <h2 className="mt-4 font-oswald font-700 uppercase tracking-tighter leading-[0.9] text-5xl lg:text-7xl">
                Where The Work<br />Gets Done
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <Link to="/facilities" className="btn-dst border border-white/30 text-white hover:bg-white hover:text-dst-ink">
                Tour The Facility <ArrowRight size={18} />
              </Link>
            </Reveal>
          </div>
          <GalleryGrid />
        </div>
      </section>

      <Testimonials />
      <FaqAccordion />
      <CTASection />
    </>
  );
}
